import networks_gen_2_plus_lte_settings from '@devices/settings/device_settings/networks_gen_2_plus_lte_settings.js';
import app_setting_empty from '@devices/settings/device_settings/app_setting_empty.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyCellGW',
	friendly_name: 'Cell GW',
	family: 'gateway',
	isPM: false,
	modes: {
		gateway: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				networks_gen_2_plus_lte_settings,
				bluetooth_gen_2,
				app_setting_empty,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
